import React, { useEffect, useState } from 'react';
import axios from '../axios/AxiosInstance';

const presets = [
  { _id: 'base-delegation', name: 'Délégation intérim', service: 'Délégation', conditions: 'Mise à disposition de personnel intérimaire. Qualification, horaires et conditions de facturation à préciser avec le client.' },
  { _id: 'base-gestion', name: 'Gestion intérim', service: 'Gestion', conditions: 'Gestion administrative du personnel présenté par le client. Prestations et conditions à adapter au besoin.' },
  { _id: 'base-placement', name: 'Placement CDD / CDI', service: 'Placement', conditions: 'Prestation de recrutement. Profil recherché, contrat, honoraires et modalités de règlement à préciser.' },
  { _id: 'base-vacation', name: 'Vacation', service: 'Vacation', conditions: 'Prestation ponctuelle. Dates, horaires, quantité et modalités de facturation à confirmer avec le client.' },
];
const endpoint = 'user/me/quotation-templates';
export default function QuotationTemplates({ kind = 'pricing', getContent, onApply }) {
  const [templates, setTemplates] = useState([]);
  const [selected, setSelected] = useState('');
  const [name, setName] = useState('');
  const [busy, setBusy] = useState(false);
  const [saveOpen, setSaveOpen] = useState(false);
  const [feedback, setFeedback] = useState('');
  const [error, setError] = useState('');
  useEffect(() => {
    let active = true;
    axios.get(endpoint).then(({ data }) => { if (active) setTemplates(Array.isArray(data) ? data : []); })
      .catch(() => { if (active) setError('Impossible de charger vos trames personnelles.'); });
    return () => { active = false; };
  }, []);
  const personal = templates.filter(template => template.kind === kind);
  const selectedTemplate = personal.find(template => template._id === selected);
  const apply = (id) => {
    const base = presets.find(template => template._id === id);
    const template = personal.find(template => template._id === id) || base;
    if (!template) return;
    const content = base ? { conditions: base.conditions, notes: '', draft: { product: base.service, contractType: base.service === 'Placement' ? 'CDI' : undefined, comment: base.conditions } } : template.content;
    onApply(JSON.parse(JSON.stringify(content)));
    setName(base ? '' : template.name);
    setError('');
    setFeedback('Modèle appliqué. Vous pouvez modifier le devis.');
  };
  const save = async (update) => {
    if (!name.trim()) { setError('Donnez un nom à votre trame.'); return; }
    const content = getContent();
    if (kind === 'pricing' && !content.products?.length) { setError('Ajoutez au moins une prestation au devis avant d’enregistrer la trame.'); return; }
    setBusy(true); setError(''); setFeedback('');
    try {
      const payload = { name: name.trim(), kind, content };
      const { data } = update ? await axios.put(`${endpoint}/${selectedTemplate._id}`, payload) : await axios.post(endpoint, payload);
      setTemplates(current => [...current.filter(template => template._id !== data._id), data]);
      setSelected(data._id);
      setSaveOpen(false);
      setFeedback('Modèle enregistré.');
    } catch { setError('La trame n’a pas pu être enregistrée. Vos saisies sont conservées.'); }
    finally { setBusy(false); }
  };
  const remove = async () => {
    if (!selectedTemplate || !window.confirm(`Supprimer la trame « ${selectedTemplate.name} » ?`)) return;
    setBusy(true); setError('');
    try {
      await axios.delete(`${endpoint}/${selectedTemplate._id}`);
      setTemplates(current => current.filter(template => template._id !== selectedTemplate._id));
      setSelected(''); setName(''); setFeedback('Trame supprimée.');
    } catch { setError('Impossible de supprimer cette trame.'); }
    finally { setBusy(false); }
  };
  return <fieldset disabled={busy} className="mb-4 rounded-xl border border-slate-200 bg-slate-50 p-4">
    <legend className="px-2 text-sm font-semibold">Modèle de devis</legend>
    <label className="block text-sm">Partir d’un modèle
      <select className="mt-1 block w-full rounded-lg border border-slate-300 bg-white p-2 text-sm" value={selected} onChange={event => {
        const id = event.target.value;
        setSelected(id); setFeedback(''); setError(''); setSaveOpen(false);
        if (id) apply(id);
      }}>
        <option value="">Sans modèle</option>
        <optgroup label="Modèles proposés">{presets.map(template => <option key={template._id} value={template._id}>{template.name}</option>)}</optgroup>
        {personal.length > 0 && <optgroup label="Mes modèles">{personal.map(template => <option key={template._id} value={template._id}>{template.name}</option>)}</optgroup>}
      </select>
    </label>
    <button type="button" onClick={() => setSaveOpen(value => !value)} aria-expanded={saveOpen} className="mt-3 text-sm text-indigo-700 underline">{saveOpen ? 'Fermer' : 'Garder ce devis comme modèle'}</button>
    {saveOpen && <div className="mt-3 border-t border-slate-200 pt-3">
      <label className="block text-sm">Nom du modèle
        <input maxLength={100} className="mt-1 block w-full rounded-lg border border-slate-300 p-2 text-sm" value={name} onChange={event => setName(event.target.value)} placeholder="Ex. Logistique" />
      </label>
      <div className="mt-3 flex flex-wrap gap-3">
        <button type="button" onClick={() => save(Boolean(selectedTemplate))} className="rounded-lg bg-indigo-700 px-3 py-2 text-sm text-white">{busy ? 'Enregistrement…' : selectedTemplate ? 'Mettre à jour' : 'Enregistrer'}</button>
        {selectedTemplate && <><button type="button" onClick={() => save(false)} className="text-sm text-indigo-700 underline">Enregistrer une copie</button><button type="button" onClick={remove} className="text-sm text-red-700 underline">Supprimer</button></>}
      </div>
    </div>}
    {feedback && <p role="status" className="mt-2 text-sm text-emerald-800">{feedback}</p>}
    {error && <p role="alert" className="mt-2 text-sm text-red-700">{error}</p>}
  </fieldset>;
}
